<div *ngIf="factor.process == 'screening'">
  <admin-lookup-factor-screening [factor]="factor" (titleEmitter)="modalTitleReceiver($event)"/>
  <admin-modal title="{{ modalTitle }}">
    <admin-lookup-common-entry></admin-lookup-common-entry>
  </admin-modal>
</div>
<div *ngIf="factor.process == 'scoring'">
  <admin-lookup-factor-scoring [factor]="factor"/>
</div>
<div *ngIf="factor.process == 'monitoring'">
  <admin-lookup-factor-monitoring [factor]="factor"/>
</div>
